/**
 * crmPortal.js — o PORTAL de acesso que vai em toda chamada a /api/tarefas.
 *
 * O backend liga/desliga o CRM por portal (functions/middleware/gateCrmPortal.js)
 * e precisa saber de QUAL portal a pessoa está usando o CRM: é o
 * `domainDetails.domainId` do AuthContext (CBTKD ou a federação do subdomínio).
 * Sem o cabeçalho `X-Portal-Id` a API responde 400.
 *
 * Por que um setter de módulo e não um parâmetro: Tarefas.service é um objeto
 * de funções chamado de dezenas de telas, nenhuma delas com o domainDetails à
 * mão. O AuthContext — dono do domainDetails — chama `definirPortalCrm` sempre
 * que ele muda, e o service lê daqui. Um lugar só escreve, um lugar só lê.
 */

let portalAtual = null;

/** Chamado pelo AuthContext quando `domainDetails.domainId` muda. */
export function definirPortalCrm(portalId) {
  portalAtual = portalId ? String(portalId) : null;
}

export function portalCrmAtual() {
  return portalAtual;
}

/** Cabeçalhos a mesclar nas chamadas a /api/tarefas (vazio enquanto o portal não resolveu). */
export function cabecalhosPortalCrm() {
  return portalAtual ? { 'X-Portal-Id': portalAtual } : {};
}
